/* eslint-disable no-shadow */

enum EnumCategoryType {
  Apillar = 'A-Pillar',
  Topic = 'Topic',
  Subtopic = 'Subtopic',
  Question = 'Question',
}

export default EnumCategoryType;
